import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { IAuthentication, IConfigurationObject, IConfigurationService, ILoginResult } from '../../../services';
import { ILoginData } from '../ILoginData';
import { ApiStatus } from '../loginPage/ApiStatus';

class LoginPanelController implements angular.IComponentController {
    apiStatus: ApiStatus;
    configuration: IConfigurationObject;
    errorMessage: string;
    isDisabled: boolean;
    isInDomain: boolean;
    isLicenseValid: boolean;
    loginData: ILoginData;
    loginForm: angular.IFormController;
    message: string;

    readonly loginMethod: (value: { loginData: ILoginData }) => angular.IPromise<ILoginResult>;

    static $inject = ['$state', '$translate', 'configurationService'];

    constructor(private _$state: angular.ui.IStateService, private _$translate: angular.translate.ITranslateService, private _configurationService: IConfigurationService) {
    }

    $onInit(): void {
        this._configurationService.getConfiguration().then((config) => {
            this.configuration = config;
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['errorMessage'] && changesObj['errorMessage'].currentValue) {
            this.message = this.translateErrors(this._$translate.instant(changesObj['errorMessage'].currentValue));
        }
    }

    login(): void {
        this.loginMethod({ loginData: this.loginData })
            .then((to) => {
                if (!this.isLicenseValid) {
                    to = { url: 'administration', params: {} as IAuthentication };
                } else if (!to) {
                    to = { url: 'workspace', params: {} as IAuthentication };
                }
                this._$state.go(to.url, to.params);
            })
            .catch((err) => {
                this.message = this.translateErrors(this._$translate.instant(err.data.error_description));
            });
    }

    private translateErrors(message: string): string {
        if (message) {
            let find = 'You must wait for';
            let regEx = new RegExp(find, 'g');
            message = message.replace(regEx, this._$translate.instant('You must wait for'));
            find = 'seconds before trying to login again';
            regEx = new RegExp(find, 'g');
            message = message.replace(regEx, this._$translate.instant('seconds before trying to login again'));
        }
        return message;
    }
}

export const wtLoginPanel: ComponentDefinition = {
    componentId: 'wtLoginPanel',
    controller: LoginPanelController,
    template: require('./loginPanel.component.html'),
    controllerAs: 'vm',
    bindings: {
        apiStatus: '<',
        emailAdmin: '<',
        errorMessage: '<',
        isDisabled: '<',
        isInDomain: '<',
        isLicenseValid: '<',
        loginMethod: '&'
    }
};
